/* eslint-disable no-console */
import configuration from '@totem/utilities/configuration';

type LogArgs = unknown[];

const logger = {
  debug: (...args: LogArgs) => {
    if (!configuration.isProd) {
      console.debug(...args);
    }
  },
  info: (...args: LogArgs) => {
    console.info(...args);
  },
  warn: (...args: LogArgs) => {
    console.warn(...args);
  },
  error: (...args: LogArgs) => {
    console.error(...args);
  },
};

export default logger;
